<template>
    <div class="mapLocaltion">
      地图定位
    </div>
</template>

<script>
import url from "../../service/base-url.js";
export default {
  name: "mapLocaltion",
  mounted() {
    // var win = window.open(url.smartDevice, "_blank");
    // win.focus();
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
